import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  EventLogStoreState,
  EventLogActions,
} from 'src/app/root-store/event-log-store/';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private eventLogStore: Store<EventLogStoreState.State>,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => new Error(error));
        }
        if (
          error.url.includes('ignoreIfError') &&
          error.status >= 400 &&
          error.status < 500
        ) {
          return throwError(() => error);
        }
        if (
          (error.status === 401 && error.error.reason !== '002') ||
          error.status > 401 ||
          error.status === 400
        ) {
          if (typeof error.error.detail === 'object') {
            let message = `${error.error.name}: `;

            // Sometimes there could be hundreds of errors
            // And we don't want to show them all
            // So lets take first 10
            error.error.detail.slice(0, 9).map((subError1) => {
              if (subError1.errors) {
                subError1.errors?.map((subError2) => {
                  message += `<li>${subError1.path ? subError1.path : ''} ${
                    subError2.message
                  }</li>`;
                });
              } else {
                message += `<li>${subError1}</li>`;
              }
            });
            if (error.error.detail.length > 10) {
              message += `<li>+ ${error.error.detail.length - 10} errors</li>`;
            }
          } else {
            if (typeof error.error === 'string') {
              this.eventLogStore.dispatch(
                new EventLogActions.Error(`Error: ${error.error}`)
              );
            } else {
              this.eventLogStore.dispatch(
                new EventLogActions.Error(
                  `${
                    error.error.detail ||
                    error.error.name ||
                    error.error.message?.response?.error?.reason ||
                    error.error.message
                  }`
                )
              );
            }
          }
        }

        /**
         * P.S.
         * error.status is used to in auth.service.ts
         * to check if refreshShouldHappen
         */
        if (
          request.method === 'GET' &&
          error.status === 401 &&
          error.error.reason !== '002'
        ) {
          // this.router.navigate(['/not-available']);
        }
        return throwError(() => error);
      })
    );
  }
}
